import React from 'react';
import { Card, CardHeader, CardContent } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { AvailabilityStatusForm } from './AvailabilityStatusForm';


export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allSeasons, allPeriods, allPackages, allStatusChoices, allAvailabilityLevels, treeObjects } = props;

  return (
    <Scrollbar>
      <Card>
        <CardHeader title={data ? 'Edytuj status dostępności' : 'Dodaj status dostępności'} sx={{ mt: -1, mb: -2 }} />
        <CardContent>
          <AvailabilityStatusForm
            data={data}
            submitCallback={submitCallback}
            handleClose={handleClose}
            allSeasons={allSeasons}
            allPeriods={allPeriods}
            allPackages={allPackages}
            allStatusChoices={allStatusChoices}
            allAvailabilityLevels={allAvailabilityLevels}
            treeObjects={treeObjects}
          />
        </CardContent>
      </Card>
    </Scrollbar>
  );
};
